// src/pages/AuthPage.js
import React, { useState, useEffect } from 'react';
import { Box, Button, Typography, Card, CardContent, Snackbar, Divider } from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';
import profitizeLogo from '../assets/profitize_logo.png'; // Adjust path if needed

function AuthPage() {
  // Auth is handled via Google OAuth redirect; no context needed here
  const [processing, setProcessing] = useState(false);

  // Removed mode state - only login is supported now
  const [error] = useState(null);
  const [snackbarErrorOpen, setSnackbarErrorOpen] = useState(false);
  // Removed success states - no registration flow

  // Clear any existing auth data on mount
  useEffect(() => {
    localStorage.clear();
  }, []);

  // Removed toggleMode function - no registration flow

  function handleGoogleSignIn() {
    setProcessing(true);
    // Redirect to backend Google OAuth endpoint
    const backendUrl = process.env.REACT_APP_API_BASE_URL || 'https://inventory-manager-backend-1-2ej0.onrender.com';
    window.location.href = `${backendUrl}/auth/google`;
  }

  return (
    <Box
      sx={{
        position: 'relative',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: { xs: 'flex-start', sm: 'center' },
        p: 2,
        py: { xs: 4, sm: 6 },
        boxSizing: 'border-box',
        overflow: 'hidden',
      }}
    >

      <Card sx={{ 
        width: '100%', 
        maxWidth: 440, 
        px: 3, py: 3.5,
        boxShadow: '0 10px 30px rgba(0,0,0,0.35)',
        my: { xs: 2, sm: 0 },
        flexShrink: 0,
        border: '1px solid rgba(255,255,255,0.06)',
        background: 'rgba(15,18,28,0.72)',
        backdropFilter: 'saturate(160%) blur(8px)',
      }}>
        <CardContent>
          <Box sx={{ textAlign: 'center', mb: 2.5 }}>
            <img
              src={profitizeLogo}
              alt="Profitize Logo"
              style={{ maxWidth: '140px' }}
            />
          </Box>

          {/* App name and tagline */}
          <Typography variant="h4" align="center" gutterBottom sx={{ fontWeight: 800 }}>
            Inventory Manager
          </Typography>
          <Typography align="center" sx={{ color: 'rgba(255,255,255,0.8)', mb: 2 }}>
            Become bankable and profitable.
          </Typography>

          <Divider sx={{ my: 2, borderColor: 'rgba(255,255,255,0.1)' }} />

          {/* Google Sign-in Button */}
          <Button
            onClick={handleGoogleSignIn}
            variant="contained"
            fullWidth
            startIcon={<GoogleIcon />}
            sx={{ 
              mb: 1.25,
              py: 1.25,
              fontSize: 16,
              fontWeight: 700,
              backgroundColor: '#4285f4',
              '&:hover': { backgroundColor: '#357ae8' } 
            }}
            disabled={processing}
          >
            Continue with Google
          </Button>
          <Typography align="center" sx={{ fontSize: 13, color: 'rgba(255,255,255,0.85)', mb: 0.5 }}>
            Use Google to sign up or sign in — no password needed.
          </Typography>
          <Typography align="center" sx={{ fontSize: 13, color: 'rgba(255,255,255,0.8)' }}>
            Get started for free.
          </Typography>

          {/* Deprecated password form remains hidden/commented below */}
          {/*
          <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
            <TextField label="Email" type="email" variant="outlined" fullWidth required value={email} onChange={(e) => setEmail(e.target.value)} />
            <TextField label="Password" type="password" variant="outlined" fullWidth required value={password} onChange={(e) => setPassword(e.target.value)} />
            <Button type="submit" variant="contained" color="primary" fullWidth disabled={processing}>Login</Button>
          </Box>
          */}
        </CardContent>
      </Card>

      <Snackbar
        open={snackbarErrorOpen}
        onClose={() => setSnackbarErrorOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        message={error}
      />
    </Box>
  );
}

export default AuthPage;
